import { put, select, take } from 'redux-saga/effects';
import queryString from 'query-string';
import { loadPlan } from 'domain/Options/actions';
import { LOAD_APPLICATION, KIOSK, IFRAME } from './constants';
import { setApplicationMode,
   setDebugLevel,
   setTranslationMode,
   displayVirtualKeyboard,
   disablePriceAnimation,
   displayPrintFormat,
   setIpexGalleryMode,
   setUpptackaMode,
   setKioskPrintMode,
   setIdleTime,
} from './actions';
import { makeSelectLocation } from './selectors';

export function* loadApplicationSaga() {
  yield take(LOAD_APPLICATION);
  const location = yield select(makeSelectLocation());
  const {
    mode,
    code,
    debug,
    translationKeys,
    translationMode,
    uitest,
    ipexGallery,
    origin,
    idleTime,
    allowPrint,
  } = queryString.parse(location.search);

  if(ipexGallery && ipexGallery.toLowerCase() === 'true'){
    yield put(setIpexGalleryMode(true));
  }

  if(origin && origin.toLowerCase() === 'upptacka'){
    yield put(setUpptackaMode(true));
  }

  if(idleTime && idleTime !== false && idleTime !== 0){
    yield put(setIdleTime(idleTime));
  }

  if(allowPrint && allowPrint.toLowerCase() === 'true'){
    yield put(setKioskPrintMode(true));
  }

  if (mode) {
    switch (mode.toLowerCase()) {
      case KIOSK:
        yield put(setApplicationMode(KIOSK));
        break;
      case IFRAME:
        yield put(setApplicationMode(IFRAME));
        break;
      default:
        break;
    }
  }

  if (debug && Number(debug)) {
    yield put(setDebugLevel(Number(debug)));
  }

  if (uitest) {
    let uiTestParams;
    if (!Array.isArray(uitest)) {
      uiTestParams = [uitest];
    } else {
      uiTestParams = uitest;
    }
    /* eslint-disable no-restricted-syntax */
    for (const param of uiTestParams) {
    /* eslint-enable no-restricted-syntax */
      switch (param.toLowerCase()) {
        case 'displayvirtualkeyboard':
          yield put(displayVirtualKeyboard(true));
          break;
        case 'disablepriceanimation':
          yield put(disablePriceAnimation(true));
          break;
        case 'displayprintformat':
          yield put(displayPrintFormat());
          break;
        default:
          break;
      }
    }
  }

  if (translationKeys && translationKeys.toLowerCase() === 'true') {
    yield put(setTranslationMode('keys'));
  }

  if (translationMode) {
    switch (translationMode.toLowerCase()) {
      case 'keys':
        yield put(setTranslationMode('keys'));
        break;
      case 'master':
        yield put(setTranslationMode('master'));
        break;
      default:
        break;
    }
  }

  if (code) {
    yield put(loadPlan(code, true));
  }
}

// All sagas to be loaded
export default loadApplicationSaga;
